import React from "react";
import EntityList from "../../EntityList/EntityList";
import { CONTROLS_POSITION } from "../../../Common/constants";

class ServicesList extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      entities: [],
    };
  }

  componentDidMount() {}

  componentWillUnmount() {}

  render() {
    const {
      name,
      entityName,
      validation,
      fields,
      renderers,
      sorting,
      allowCreate,
      allowClone,
      allowEdit,
      allowDelete,
      allowExport,
      exportFileName,
      reorder,
      filterFields,
      showTotalRecords,
    } = this.props.config;
    const {
      entities,
      loading,
      entityError,
      entityResult,
      handleCreate,
      handleEdit,
      success,
    } = this.props;

    return (
      <EntityList
        loading={loading}
        entityName={entityName}
        filterFields={filterFields}
        entities={entities}
        validation={validation}
        renderers={renderers}
        name={name}
        fields={fields}
        entityError={entityError}
        entityResult={entityResult}
        handleCreate={handleCreate}
        handleEdit={handleEdit}
        currentLocale={this.props.config.locale}
        success={success}
        sorting={sorting}
        allowCreate={allowCreate}
        allowClone={allowClone}
        allowEdit={allowEdit}
        allowDelete={allowDelete}
        allowExport={allowExport}
        exportFileName={exportFileName}
        reorder={reorder}
        maxColumnWidth={500}
        horizontalScroll
        controlsPosition={CONTROLS_POSITION.TOP}
        showTotalRecords={showTotalRecords}
        hasFilters
      />
    );
  }
}

ServicesList.propTypes = {};

ServicesList.defaultProps = {};

export default ServicesList;
